<mat-toolbar *ngIf="showHeader">
    <button (click)="goBack()" class="ka-icon">
        <mat-icon class="ka-selectIos">arrow_back_ios</mat-icon>
        <div class="ka-nav-text">Zurück</div>
    </button>

</mat-toolbar>
<div class="ka-web-container" [innerHTML]="htmlText"></div>